import * as Api from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';
import { IImpersonationContextComponentProps } from '../../../../models';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { getShortenedString, isTemplateNew } from '../../../../models/UiUtils';
import { ITemplateCard } from '../../../../viewmodels/AppViewModels';
import { CampaignExpiryHint } from '../../../components/campaigns/CampaignExpiryHint';
import {
	CampaignTemplateCardCta,
	CampaignTemplateCardMenu,
	CampaignTemplateCardTruncatedBody,
} from '../../../components/templateCards/CampaignTemplateCard/presentation';
import { bs } from '../../../styles/styles';
import { styleSheet } from './styles';

export interface ICampaignTemplateCardProps extends IImpersonationContextComponentProps {
	card: ITemplateCard;
	isAccountTemplate?: boolean;
	onCtaClicked?(e?: React.MouseEvent<Element>): void;
	onDelete?(): void;
	onShare?(isShared: boolean): void;
	styles?: StyleDeclarationValue[];
}

export const DecafTemplateCard = ({
	card,
	isAccountTemplate,
	onCtaClicked,
	onDelete,
	onShare,
	styles,
}: ICampaignTemplateCardProps) => {
	const userSession = useUserSession();
	const expirationDate = card?.schedule?.expirationDate ? moment(card?.schedule?.expirationDate) : undefined;
	/** Moved not necessarily desirable code */
	const summary = card?.summary;
	const isLargeScreen = useMediaQuery({ minWidth: 1200 });
	const maxCharCount = isLargeScreen ? 120 : 100;
	const shortSummary = summary ? getShortenedString(summary?.trim(), maxCharCount) : '';
	/** -- */

	const isNew = isTemplateNew(card);

	return (
		<div className={css(styleSheet.container, ...(styles || []))}>
			{isAccountTemplate ? (
				<CampaignTemplateCardMenu card={card} userSession={userSession} onDelete={onDelete} onShare={onShare} />
			) : null}
			<div className={css(styleSheet.headerContainer)}>
				<div className={css(styleSheet.nameContainer)}>
					<div className={css(bs.truncateText)} onClick={onCtaClicked}>
						{card.name || 'Custom Post'}{' '}
					</div>
					{expirationDate ? <CampaignExpiryHint expirationDate={expirationDate} /> : null}
					{isNew ? <span className={css(styleSheet.newItem)}>(New!)</span> : null}
				</div>
				<div className={css(styleSheet.popoverContainer)} />
			</div>
			<div className={css(styleSheet.textContainer)}>
				<CampaignTemplateCardTruncatedBody
					text={shortSummary}
					truncated={summary?.length >= maxCharCount}
					showReadMore={false}
				/>
			</div>
			<CampaignTemplateCardCta card={card} templateType={Api.TemplateType.Email} />
			{card.scope === Api.TemplateScope.Account && card.creator?.id !== userSession.user?.id ? (
				<div className={css(styleSheet.sharedByFooter)}>
					{card.creator?.firstName || card.creator?.lastName
						? `Shared by ${card.creator?.firstName} ${card.creator?.lastName}`
						: 'Shared'}
				</div>
			) : null}
		</div>
	);
};
